import { render, staticRenderFns } from "./CommentsDialog.vue?vue&type=template&id=5265d8fa&scoped=true&"
import script from "./CommentsDialog.vue?vue&type=script&lang=js&"
export * from "./CommentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265d8fa",
  null
  
)

export default component.exports